define('common/presentation/iconNames',[], function () {
    // foo.svg -> svg-foo
    return {
        actionAdd: 'svg-plus',
        actionCall: 'svg-calls',
        actionChat: 'svg-web-chat',
        actionClose: 'svg-remove',
        actionCopy: 'svg-copy',
        actionDeactivate: 'svg-deactivate',
        actionDelete: 'svg-delete',
        actionEdit: 'svg-edit',
        actionEmail: 'svg-email',
        actionFilter: 'svg-content-filter',
        actionHangup: 'svg-hangup',
        actionMessage: 'svg-messages',
        actionPhoneRinging: 'svg-ringing',
        actionPlay: 'svg-play',
        actionPause: 'svg-pause',
        actionReactivate: 'svg-reactivate',
        actionRefresh: 'svg-refresh',
        actionRemove: 'svg-remove',
        actionSettings: 'svg-settings',
        addContact: 'svg-add-contact-web',
        analyticsGraphLegend: 'svg-chart-legend-item',
        appStore: 'svg-app-store',
        arrowInbound: 'svg-arrow-inbound',
        arrowOutbound: 'svg-arrow-outbound',
        arrowDown: 'svg-arrow',
        attachment: 'svg-attachment',
        audioFile: 'svg-audio-file',
        audioRecording: 'svg-bulls-eye',
        audioRecordingStop: 'svg-bulls-eye-stop',
        autoAttendant: 'svg-auto-attendant',
        autoAttendantSubMenu: 'svg-auto-attendant-sub-menu',
        billingDownload: 'svg-billing-download',
        billingPlan: 'svg-billing-plan',
        blockedContact: 'svg-blocked-contact',
        blocking: 'svg-blocked-contact',
        calendar: 'svg-calendar',
        outboundCalls: 'svg-phone',
        callFlowHangup: 'svg-hangup',
        callFlowLoop: 'svg-infinity',
        callFlowRinging: 'svg-ringing',
        callQueue: 'svg-call-queue',
        callRecording: 'svg-call-recording',
        callRecordingBadge: 'svg-recording-badge',
        callRecordingBadgeBoth: 'svg-recording-badge-both',
        caret: 'svg-caret',
        checkmark: 'svg-checkmark',
        companyAddressBook: 'svg-company-address-book',
        confirmationSuccess: 'svg-circle-with-checkmark',
        confirmationFailed: 'svg-circle-with-x',
        confirmationError: 'svg-round-triangle-with-exclamation',
        contact: 'svg-contact',
        contactBlocked: 'svg-contact-blocked',
        contactPermissions: 'svg-contact-active-navigation',
        contactSupport: 'svg-contact-support',
        contentFilter: 'svg-content-filter',
        denied: 'svg-denied',
        device: 'svg-device',
        disabledMessages: 'svg-disabled-messages',
        disabledPhone: 'svg-disabled-phone',
        disabledRecording: 'svg-disabled-recording',
        download: 'svg-download',
        dropdownArrow: 'svg-arrow-dropdown',
        editPencil: 'svg-edit-pencil',
        forwardingNumber: 'svg-forwarding-number',
        googlePlay: 'svg-google-play',
        group: 'svg-group',
        help: 'svg-help',
        helpCenter: 'svg-help-center',
        hourglass: 'svg-hourglass',
        integration: "svg-integration",
        link: 'svg-link',
        liveReceptionistScript: 'svg-live-receptionist-script',
        loginAnimation: 'svg-login-animation-group',
        logoBadge: 'svg-patlive-badge-logo',
        logoText: 'svg-patlive-text-logo',
        logoTextWhite: 'svg-patlive-text-logo-white',
        mainNavAnalytics: 'svg-analytics',
        mainNavCalls: 'svg-calls',
        mainNavContacts: 'svg-contact',
        mainNavMessages: 'svg-messages',
        mainNavMore: 'svg-more',
        mainNavInbox: 'svg-inbox',
        mainNavRecordings: 'svg-call-recording',
        mainNavSettings: 'svg-settings',
        mainNavAnalyticsActive: 'svg-analytics-active',
        mainNavCallsActive: 'svg-calls-active',
        mainNavContactsActive: 'svg-contact-active',
        mainNavMessagesActive: 'svg-messages-active',
        mainNavMoreActive: 'svg-more',
        mainNavInboxActive: 'svg-inbox-active',
        mainNavRecordingsActive: 'svg-call-recording',
        mainNavSettingsActive: 'svg-settings-active',
        messageSending: 'svg-messages-sending',
        messages: 'svg-messages',
        messagesFailed: 'svg-messages-failed',
        messagesHourglass: 'svg-messages-hourglass',
        messagesSent: 'svg-messages-sent',
        moreInfo: 'svg-info-i',
        numberPickerFailed: 'svg-circle-x',
        numberPickerLocal: 'svg-local',
        numberPickerLocation: 'svg-map-marker',
        numberPickerRemove: 'svg-circle-x',
        numberPickerSearch: 'svg-number-picker-search',
        numberPickerTollfree: 'svg-toll-free',
        numberPickerTransfer: 'svg-transfer',
        onboardingArrowForward: 'svg-arrow-forward',
        onboardingArrowForwardFilled: 'svg-arrow-forward-filled',
        onboardingCheckmark: 'svg-circle-checkmark-signup',
        onboardingFooterCircle: 'svg-circle-filled',
        openInNew: 'svg-open-in-new',
        optionIcon: 'svg-bulls-eye',
        outboundCallingCampaign: 'svg-outbound-calling-campaign',
        patliveMessenger: 'svg-patlive-messenger',
        phone: 'svg-skinny-phone',
        phoneAdd: 'svg-phone-add',
        phoneForward: 'svg-phone-forward',
        phoneNumber: 'svg-phone-number',
        picture: 'svg-picture',
        recording: 'svg-recording',
        scheduledReport: 'svg-scheduled-report',
        schedule: 'svg-calendar',
        scheduleSegment: 'svg-calendar',
        search: 'svg-search',
        send: 'svg-send',
        showPassword: 'svg-show-password',
        sidebarAccountProfile: 'svg-billing-profile',
        sidebarAutoAttendants: 'svg-auto-attendant',
        sidebarBillCycleToDate: 'svg-bill-cycle-to-date',
        sidebarCallQueues: 'svg-call-queue',
        sidebarBillingHistory: 'svg-billing-history',
        sidebarDevices: 'svg-device',
        sidebarExtensions: 'svg-extension',
        sidebarForwardingNumbers: 'svg-forwarding-number',
        sidebarGroups: 'svg-group',
        sidebarHostedNumbers: 'svg-phone-number',
        sidebarIntegrations: 'svg-sidebar-integrations',
        sidebarLiveReceptionistScripts: 'svg-live-receptionist-script',
        sidebarMakeAPayment: 'svg-make-a-payment',
        sidebarMessagingCompliance: 'svg-messages',
        sidebarMyProfile: 'svg-user',
        sidebarPaymentMethods: 'svg-payment-method',
        sidebarOutboundCallingCampaigns: 'svg-outbound-calling-campaign',
        sidebarPlans: 'svg-billing-plan',
        sidebarPrompts: 'svg-audio-file',
        sidebarReports: 'svg-scheduled-report',
        sidebarSchedules: 'svg-calendar',
        sidebarSubscriptions: 'svg-inbox',
        sidebarUsers: 'svg-user',
        sidebarVoicemail: 'svg-voicemail',
        sidebarWebChats: 'svg-web-chat',
        signupArrowForward: 'svg-arrow-forward',
        signupArrowForwardFilled: 'svg-arrow-forward-filled',
        signupCheckmark: 'svg-circle-checkmark-signup',
        signupConfirmation: 'svg-confirmation-checkmark',
        signupConfirmationAirwaves: 'svg-confirmation-airwaves',
        signupConfirmationDesktop: 'svg-confirmation-desktop-icon',
        signupConfirmationDevice: 'svg-confirmation-mobile-icon',
        signupFooterCircle: 'svg-circle-filled',
        signupNumberLocal: 'svg-local-phone-type',
        signupNumberTollfree: 'svg-toll-phone-type',
        signupNumberTransfer: 'svg-port-phone-type',
        signupPorting1: 'svg-signup-porting-form-1',
        signupPorting2: 'svg-signup-porting-form-2',
        signupPorting3: 'svg-signup-porting-form-3',
        signupUser: 'svg-user-icon',
        signupVerticalDots: 'svg-vertical-dots',
        signupWarning: 'svg-signup-warning-icon',
        sortArrow: 'svg-arrow-up',
        sortCollapseAll: 'svg-sort-collapse-all',
        sortEmail: 'svg-sort-email',
        sortExpandAll: 'svg-sort-expand-all',
        sortFrequency: 'svg-sort-frequency',
        sortName: 'svg-sort-name',
        sortPhoneNumber: 'svg-sort-phone-number',
        sortRecentlyAdded: 'svg-sort-recently-added',
        sortRecentlyModified: 'svg-sort-recently-modified',
        underConstruction: 'svg-under-construction',
        uploadPhoto: 'svg-upload-photo',
        user: 'svg-user',
        userSettingsBilling: 'svg-bill-cycle-to-date',
        userSettingsHelpCenter: 'svg-help',
        userSettings: 'svg-user',
        userSettingsSignOut: 'svg-sign-out',
        userSettingsSystem: 'svg-settings',
        videoExpand: 'svg-video-expand',
        videoMinimize: 'svg-video-minimize',
        videoMute: 'svg-video-mute',
        videoPause: 'svg-video-pause',
        videoPlay: 'svg-video-play',
        videoUnmute: 'svg-video-unmute',
        viewInThread: 'svg-view-in-thread',
        voicemail: 'svg-voicemail',
        voicemailBox: 'svg-voicemail',
        warningAttention: 'svg-attention',
        warningCheckmark: 'svg-checkmark',
        webChatWidget: 'svg-web-chat',
        yourAddressBook: 'svg-your-address-book'
    };
});

